import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { AdminProviderVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";

export const retrieveProvider = createAsyncThunk<Nullable<AdminProviderVM>, string, { extra: Partial<Dependencies> }>(
  "providers/retrieveProvider",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getProvider(id);
  },
);
